import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import CustomizedBreadcrumbs from "../../components/Custom/CustomizedBreadcrumbs";
import CustomizedMenuBox from "../../components/Custom/CustomizedMenuBox";
import { useAuth, usePermission } from "../../hooks/use-auth";

const Manufacture = () => {
  const { permissions } = useAuth();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const [allPermissionList, setAllPermissionList] = useState([]);

  const breadcrumbs = [
    {
      name: t("manufacture.index"),
    },
  ];

  const isAdmin = "ADMIN__ADMIN__ADMIN";

  useEffect(() => {
    setAllPermissionList(permissions);
  }, [permissions]);
  const {
    bomPermission,
    manufactureOrderPermission,
    workOrderPermission,
    manufactureReportPermission,
  } = usePermission();

  const menuList = [
    allPermissionList.some((permission) =>
      [bomPermission.VIEW, isAdmin].includes(permission)
    ) && {
      title: t("manufacture.bom.index"),
      navigateTo: "bom",
      testId: "navigate-to-bom",
    },
    allPermissionList.some((permission) =>
      [manufactureOrderPermission.VIEW, isAdmin].includes(permission)
    ) && {
      title: t("manufacture.order.index"),
      navigateTo: "order",
      testId: "navigate-to-order",
    },
    allPermissionList.some((permission) =>
      [workOrderPermission.VIEW, isAdmin].includes(permission)
    ) && {
      title: t("manufacture.workOrder.index"),
      navigateTo: "work-order",
      testId: "navigate-to-work-order",
    },
    allPermissionList.some((permission) =>
      [manufactureReportPermission.VIEW, isAdmin].includes(permission)
    ) && {
      title: t("report"),
      navigateTo: "report",
      testId: "navigate-to-report",
    },
  ];

  const formatMenuList = menuList.filter((menu) => menu !== false);

  const renderMenuList = () =>
    formatMenuList.map((menu) => (
      <Grid item xs={12} sm={6} md={3} lg={3} xl={2} key={menu.title}>
        <CustomizedMenuBox
          isGridItem
          testId={menu.testId}
          title={menu.title}
          linkTo={`${pathname}/${menu.navigateTo}`}
        />
      </Grid>
    ));

  return (
    <>
      <CustomizedBreadcrumbs breadcrumbs={breadcrumbs} />
      <Box sx={{ my: 2, textAlign: "-webkit-center" }}>
        <Grid container spacing={1}>
          {renderMenuList()}
        </Grid>
      </Box>
    </>
  );
};

export default Manufacture;
